<script setup>
import {useForm} from "@inertiajs/vue3"
import {computed, inject, onBeforeMount, ref} from "vue"
import Swal from "sweetalert2"
import TwoIntegrations from "@/components/Dashboard/TwoIntegrations"
import ConfigureFlow from "@/components/Dashboard/ConfigureFlow"
import FormButton from "@/components/Shared/Form/Button"

const {user} = defineProps({
  user: Object
})

const trans = inject('trans')

const initialLoadingIntegration = ref(true)
const integration1 = ref(null)
const integration2 = ref(null)
const form = useForm({
  coveredFlows: []
})

const integrationId = computed(() => route().params.integration)
const baseApi = computed(() => `/user/${user.id}/integration/${integrationId.value}`)
const fetchIntegrations = async () => {
  await axios
    .get(baseApi.value)
    .then(({data}) => {
      integration1.value = data.data.integration1
      integration2.value = data.data.integration2
    })
    .finally(() => initialLoadingIntegration.value = false)
    .catch(({response}) => handleError(response.error))
}

onBeforeMount(fetchIntegrations)

const handleError = (error) => Swal.fire({
  text: error.message,
  icon: 'error',
  showConfirmButton: false,
  timer: 2000,
})

const saveCoveredFlows = async () => {
  form.post(`${baseApi.value}/flows`, {
      onSuccess: () => {
        Swal.fire({
          text: trans('dashboard.alerts.success_configure_flow'),
          icon: 'success',
          showConfirmButton: false,
          timer: 2000,
        })

        this.$inertia.visit(
          this.$route('dashboard.user.integrations.overview', {user: this.user.id, integration: this.integrationId})
        )
      }
    }
  )
}
</script>
<script>
import DashboardLayout from "@/Layouts/DashboardLayout"
import IntegrationLayout from "@/Layouts/IntegrationLayout.vue";

export default {
  layout: [DashboardLayout, IntegrationLayout]
}
</script>
<template>
  <div>
    <two-integrations
      :loading="initialLoadingIntegration"
      :integration1="integration1"
      :integration2="integration2"
    />
  </div>
  <div class="my-4">
    <configure-flow @selected-flows="(flows) => form.coveredFlows = flows"/>
  </div>
  <div class="tile mb-4 p-6">
    <div class="mt-2 mb-6">
      <form-button @click.native="saveCoveredFlows"
                   :value="trans('dashboard.integrations.configure_flows.i_agree')"
                   :processing="form.processing"/>

      <inertia-link class="button button_danger"
                    :href="$route('dashboard.user.integrations.overview', [user, integrationId])"
                    :disabled="form.processing">
        {{ trans('dashboard.integrations.configure_flows.i_disagree') }}
      </inertia-link>
    </div>
  </div>
</template>
